import { SINGLEUSETOKENS_CHECK, SINGLEUSETOKENS_REFRESH } from 'constants/apis';
import apiClient from 'helpers/axios';
import { TokenError, TokenExpiredError, TokenInvalidError } from './errors';

export const TokenTypes = {
  COMPLETE_SETUP: 'completeSetup',
  CONFIRM_EMAIL: 'confirmEmail',
};

export function withTokenErrorHandler(tokenRequestFn) {
  return async (...args) => {
    try {
      return await tokenRequestFn(...args);
    } catch (error) {
      if (error.response) {
        const { data: { errorCode } = {} } = error.response;
        switch (errorCode) {
          case TokenError.ERROR_CODE_TOKEN_EXPIRED:
            throw new TokenExpiredError();
          case TokenError.ERROR_CODE_TOKEN_INVALID:
            throw new TokenInvalidError();
          default:
            throw error;
        }
      }

      throw error;
    }
  };
}

export const checkToken = withTokenErrorHandler(async (token, type) => {
  const { data } = await apiClient.post(
    SINGLEUSETOKENS_CHECK,
    {
      token,
    },
    {
      params: {
        type,
      },
    }
  );

  return data;
});

export const refreshToken = withTokenErrorHandler(async (expiredToken, type) => {
  const { data } = await apiClient.post(
    SINGLEUSETOKENS_REFRESH,
    {
      token: expiredToken,
    },
    {
      params: {
        type,
      },
    }
  );

  return data;
});
